import Auth from '../Helpers/auth';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// GET: All the courses - Not a protected route
async function httpGetAllCourses(admin = false) {
  try {
    const url = admin ? `${API_URL}/courses?admin=true` : `${API_URL}/courses`;
    // console.log('httpGetAllCourses -> fetching', { url, admin });
    let courses = await fetch(url);
    return await courses.json();
  } catch (err) {
    return err;
  }
}

// GET: Gets a single course - Not a protected route
async function httpGetSingleCourse(id, admin = false) {
  const url = admin
    ? `${API_URL}/courses/${id}?admin=true`
    : `${API_URL}/courses/${id}`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (!response.ok) {
      const error = new Error(data?.msg || 'Unable to get course');

      error.status = response.status;
      error.data = data;

      throw error;
    }

    return data;
  } catch (err) {
    console.error('httpGetSingleCourse error:', err);

    throw err;
  }
}
// GET: If the course if a part to
async function httpIsPartTwo(id) {
  try {
    let response = await fetch(`${API_URL}/courses/is-part-two/${id}`);
    return await response.json();
  } catch (err) {
    return err;
  }
}

// PUT: Buys a course - Protected route
async function httpBuyCourse(data) {
  const token = Auth.getToken();

  return await fetch(`${API_URL}/courses/buy`, {
    method: 'put',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify(data),
  });
}

// POST: Send the course info
async function httpEmailCourseInfo(email, courseName, userName, userId) {
  const token = Auth.getToken();
  return await fetch(`${API_URL}/courses/email-course-info`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({ email, courseName, userName, userId }),
  });
}
// POST: Test for sending purchased course email to employee
async function httpTestSendPurchasedCourseForEmployee(
  userId,
  courseName,
  companyName
) {
  const token = Auth.getToken();
  return await fetch(`${API_URL}/orders/test-send-employee-course-email`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify({ userId, courseName, companyName }),
  });
}

export {
  httpGetAllCourses,
  httpGetSingleCourse,
  httpBuyCourse,
  httpEmailCourseInfo,
  httpIsPartTwo,
  httpTestSendPurchasedCourseForEmployee,
};
